import { BareInput } from "components/DesignSystem/TextInput/TextInput";
import { Field, FieldAttributes, FieldProps } from "formik";
import { NumericFormat } from "react-number-format";
import { ComponentProps, MouseEvent, ReactNode } from "react";

export const NumericInput = ({
  fieldProps = {},
  numericProps = {},
  label,
  storeNumeric = false,
  required = false,
}: {
  fieldProps?: FieldAttributes<any>;
  numericProps?: ComponentProps<typeof NumericFormat> &
    ComponentProps<typeof BareInput>;
  label?: ReactNode;
  storeNumeric?: boolean;
  required?: boolean;
}) => (
  <Field {...fieldProps}>
    {({ field, form }: FieldProps) => (
      <>
        <NumericFormat
          {...field}
          required={required}
          label={label}
          {...numericProps}
          onClick={(event: MouseEvent<HTMLInputElement>) => {
            // @ts-ignore
            if (event.target.value?.includes?.("0.00")) {
              // @ts-ignore
              event.target?.select();
            }
          }}
          customInput={BareInput}
          onValueChange={(values, ...rest) => {
            const { value, floatValue } = values;
            numericProps.onValueChange?.(values, ...rest);
            if (storeNumeric) {
              return form.setFieldValue(field.name, floatValue || 0);
            }

            return form.setFieldValue(field.name, value);
          }}
          onChange={() => {}}
        />
      </>
    )}
  </Field>
);
